// extracted by mini-css-extract-plugin
export var bodySections = "_av-8";
export var gray = "_av-7";
export var green = "_av-4";
export var iconContainer = "_av-9";
export var iconWidgetContainer = "_av-1";
export var phoneIcon = "_av-2";
export var red = "_av-5";
export var statusDot = "_av-3";
export var widgetContainer = "_av-0";
export var yellow = "_av-6";